import React from 'react';
import { ShieldCheck, Lock, Award, CreditCard, CheckCircle } from 'lucide-react';
interface TrustBadgesProps {
  className?: string;
}
export function TrustBadges({
  className = ''
}: TrustBadgesProps) {
  return <div className={`flex justify-center gap-3 mt-4 flex-wrap ${className}`} data-id="element-414">
      <div className="flex items-center gap-1.5 text-[11px] text-gray tracking-[0.3px] bg-white/5 border border-white/10 px-2.5 py-1.5 rounded-[6px]" data-id="element-415">
        <Lock className="w-3.5 h-3.5 text-gold" data-id="element-416" />
        <span data-id="element-417">Compra Segura SSL</span>
      </div>
      <div className="flex items-center gap-1.5 text-[11px] text-gray tracking-[0.3px] bg-white/5 border border-white/10 px-2.5 py-1.5 rounded-[6px]" data-id="element-418">
        <Award className="w-3.5 h-3.5 text-gold" data-id="element-419" />
        <span data-id="element-420">Garantía 7 días</span>
      </div>
      <div className="flex items-center gap-1.5 text-[11px] text-gray tracking-[0.3px] bg-white/5 border border-white/10 px-2.5 py-1.5 rounded-[6px]" data-id="element-421">
        <ShieldCheck className="w-3.5 h-3.5 text-gold" data-id="element-422" />
        <span data-id="element-423">Datos Encriptados</span>
      </div>
      <div className="flex items-center gap-1.5 text-[11px] text-gray tracking-[0.3px] bg-white/5 border border-white/10 px-2.5 py-1.5 rounded-[6px]" data-id="element-424">
        <CheckCircle className="w-3.5 h-3.5 text-green-500" data-id="element-425" />
        <span data-id="element-426">Mercado Pago Verificado</span>
      </div>
    </div>;
}